import React from "react";

const MapCard = ({ data }) => {



    let mapDetails = JSON.parse(data)

    console.log("mapDetails", mapDetails)

    // const mapUrl = `https://maps.google.com/maps?q=${data?.latitude},${data?.longitude}&z=15&output=embed`;
    const mapUrl = `https://maps.google.com/maps?q=${mapDetails?.latitude},${mapDetails?.longitude}&z=15&output=embed&markers=color:red%7C${mapDetails?.latitude},${mapDetails?.longitude}`;
    // const mapUrl = `https://www.google.com/maps?q=${data?.latitude},${data?.longitude}&hl=es;z=14&output=embed`;
    console.log('mapUrl', mapUrl)
    return (
        <div className="bg-white p-4 rounded-xl shadow border ">
            {/* <h3 className="text-xl font-semibold mb-1">{title}</h3>
            <p className="text-gray-600 mb-3">{description}</p> */}
            <div className="w-full h-40 rounded-lg overflow-hidden">
                <iframe
                    // title={title}
                    width="100%"
                    height="100%"
                    loading="lazy"
                    allowFullScreen
                    src={mapUrl}
                    style={{ border: 0 }}
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </div>
    );
};

// const App = () => {
//   const locations = [
//     {
//       id: 1,
//       lat: 40.7128,
//       lng: -74.006,
//       title: "New York",
//       description: "The city that never sleeps.",
//     },
//     {
//       id: 2,
//       lat: 34.0522,
//       lng: -118.2437,
//       title: "Los Angeles",
//       description: "City of Angels.",
//     },
//   ];

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       <h2 className="text-2xl font-bold mb-4">Map Cards</h2>
//       {locations.map((loc) => (
// <MapCard
//   key={loc.id}
//   lat={loc.lat}
//   lng={loc.lng}
//   title={loc.title}
//   description={loc.description}
// />
//       ))}
//     </div>
//   );
// };

export default MapCard;
